import {pageInfo, initPage, uploadOrder, submit, downloadTemplate, deleteOrder} from './../api';
import { Message } from 'element-ui';
const bacth = {
  namespaced: true,
  state: {
    total:0,
    orderId: null,
    pageResp:null,
    initPageObj: null,
    uploadOrderResp: null,
    submitResp: null,
    downloadTemplateData: null,
    deleteOrderData: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data;
    },
    UPLOAD_ORDER(state,data){
      state.uploadOrderResp = data;
    },
    SUBMIT_ORDER(state,data){
      state.submitResp = data;
    },
    DOWN_LOAD_TEMPLATE(state,data){
      state.downloadTemplateData = data;
    },
    DELETE_DATA(state,data){
      state.deleteOrderData = data;
    },
    SET_ORDER_ID(state,data){
      state.orderId = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //批量上传
    async uploadOrder({commit}, obj){
      let resp = await uploadOrder(obj);
      commit('UPLOAD_ORDER', resp);
    },
    //批量上传
    async submit({commit}, obj){
      let resp = await submit(obj);
      commit('SUBMIT_ORDER', resp);
    },
    //模版下载
    async downloadTemplate({commit}, obj){
      let resp = await downloadTemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //删除订单
    async deleteOrder({commit}, obj){
      let resp = await deleteOrder(obj);
      commit('DELETE_DATA', resp);
    },
    async setOrderId({commit}, data){
      commit('SET_ORDER_ID', data);
    },
  }
}
export default bacth



// WEBPACK FOOTER //
// ./src/page/order/batch/store/batch.store.js